// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"61":"b2142c9221e090003ca4","208":"f1602afb354258bebafe","232":"2ab067f9d5ab0435331c","824":"1a3bbc4de5689c3c3caa","945":"c47dc4ef36f18984c171"}[chunkId] + ".js";
};